import { ColumnBase, ColumnComponent } from '@progress/kendo-angular-grid';

export const isColumnSticky = (col: ColumnComponent | ColumnBase): boolean => {
  return col.sticky || (typeof col.cssClass == 'string' && col.cssClass.includes('k-grid-content-sticky'));
};

export const isColumnReorderable = (col: ColumnComponent | ColumnBase): boolean => {
  return col.reorderable;
};
